var url, newUrl, t = null;
$(function(){

    if (typeof(useFormaatCustom) !== "undefined")
    {
        $('#formaat-custom').trigger('click');
    }
    if (typeof(useVierkantRond) !== "undefined")
    {
        $('.product-formaat-blok-input').keyup(function() {
            $('.product-formaat-blok-input').val($(this).val());
        });
    }

    $('.product-formaat-blok-input').keyup(function() {
        var value = $(this).val();
        if(value && value < 1) {
            $(this).val(1);
        }
        var $parent = $(this).parent();
        var $custom = $parent.find('#formaat-custom');
        $custom.attr('data-breedte', $('input[name=custom_formaat_breedte').val());
        $custom.attr('data-hoogte', $('input[name=custom_formaat_hoogte').val());
        urlFormatter();
        updatePrices(false, 200);
    });

    url = newUrl = location.protocol + '//' + location.host + location.pathname;
    prefillOptions();
    $(".product-formaat-blok").click(function(){
        $(".product-formaat-blok").removeClass("product-formaat-blok-active");
        $(this).toggleClass("product-formaat-blok-active");
        var radio = $(this).find(':input[name="producten_formaat_id"]');
        radio.attr('checked', true);
        radio.trigger('change');
        $(':input[name="custom_formaat_hoogte"]').attr('required', radio.val() == 'custom');
        $(':input[name="custom_formaat_breedte"]').attr('required', radio.val() == 'custom');
        urlFormatter();
    });

    $(".radio-optie-materiaal .product-optie-radio-item").on('click touchend',function() {
        /* Radio Button */
        $('.radio-optie-materiaal .product-optie-radio-item-leeg').removeClass("radio-aan-kleur");
        $(this).find('.product-optie-radio-item-leeg').toggleClass("radio-aan-kleur");
        $('.radio-optie-materiaal .product-optie-radio-item-vol').removeClass("radio-aan");
        $(this).find('.product-optie-radio-item-vol').toggleClass("radio-aan");
        $(".radio-optie-materiaal .product-optie-radio-item").removeClass("product-optie-radio-item-active");
        $(this).toggleClass("product-optie-radio-item-active");
        checkSave(this);

        urlFormatter();
    });

    $(".radio-optie-belijming .product-optie-radio-item").on('click touchend', function() {
        /* Radio Button */
        $('.radio-optie-belijming .product-optie-radio-item-leeg').removeClass("radio-aan-kleur");
        $(this).find('.product-optie-radio-item-leeg').toggleClass("radio-aan-kleur");
        $('.radio-optie-belijming .product-optie-radio-item-vol').removeClass("radio-aan");
        $(this).find('.product-optie-radio-item-vol').toggleClass("radio-aan");
        $(".radio-optie-belijming .product-optie-radio-item").removeClass("product-optie-radio-item-active");
        $(this).toggleClass("product-optie-radio-item-active");
        checkSave(this);

        urlFormatter();
    });

    $(".radio-optie-afwerking .product-optie-radio-item").on('click touchend', function() {
        /* Radio Button */
        $('.radio-optie-afwerking .product-optie-radio-item-leeg').removeClass("radio-aan-kleur");
        $(this).find('.product-optie-radio-item-leeg').toggleClass("radio-aan-kleur");
        $('.radio-optie-afwerking .product-optie-radio-item-vol').removeClass("radio-aan");
        $(this).find('.product-optie-radio-item-vol').toggleClass("radio-aan");
        $(".radio-optie-afwerking .product-optie-radio-item").removeClass("product-optie-radio-item-active");
        $(this).toggleClass("product-optie-radio-item-active");
        checkSave(this);

        urlFormatter();
    });

    $(".radio-optie-oplage .product-optie-radio-item-oplage").on('click touchend', function() {
        /* Radio Button */
        $('.radio-optie-oplage .product-optie-radio-item-leeg').removeClass("radio-aan-kleur");
        $(this).find('.product-optie-radio-item-leeg').toggleClass("radio-aan-kleur");
        $('.radio-optie-oplage .product-optie-radio-item-vol').removeClass("radio-aan");
        $(this).find('.product-optie-radio-item-vol').toggleClass("radio-aan");
        checkSave(this);

        urlFormatter();
    });

    if (typeof(isAanbieidng) !== "undefined")
    {
        $.fancybox.showLoading();

        $('input[name=custom_formaat_breedte]').val(breedte);
        $('input[name=custom_formaat_hoogte]').val(hoogte);

        $('input[name=custom_formaat_breedte]').keyup();
        $('input[name=custom_formaat_breedte]').click();

        $('#formaat-custom').change();

        setTimeout(function() {
            $('input[name=producten_materiaal_id][value=' + materiaal + ']').click().change();
        }, 1000);

        setTimeout(function() {
            $('input[name=producten_belijming_id][value='+belijming+']').click().change();
        }, 2000);


        setTimeout(function() {
            $('input[name=opties-oplage][value='+oplage+']').click().change();
            $.fancybox.hideLoading();
        }, 3000);
    }


    $('.product-optie-radio-item-hover').hover(function(){
        var radio = $(this).find(':input');
        if (!radio.is('checked'))
        {
            var container = $(this).parent('.product-optie-radio-item-container');
            container.find('.product-optie-radio-item-active').removeClass('product-optie-radio-item-active');
            $(this).addClass('product-optie-radio-item-active');
            selectEigenschap($(this).attr('data-class'), $(this).attr('data-id'));
        }
    }, function(){
        var radio = $(this).find(':input');
        if (!radio.is('checked'))
        {
            var container = $(this).parent('.product-optie-radio-item-container');
            var activeRadio = container.find('input[type="radio"]:checked');
            if (activeRadio.length > 0)
            {
                container.find('.product-optie-radio-item-active').removeClass('product-optie-radio-item-active');
                var label = $('label[for="' + activeRadio.attr('id') + '"]');
                label.addClass('product-optie-radio-item-active');
                selectEigenschap(label.attr('data-class'), label.attr('data-id'));
            }
        }
    });


});

function checkSave(e) {
    $(e).find('input').change();
    $(e).find('input').prop("checked", true)
}

function updateSpecificatieFilters(form)
{
    $.fancybox.showLoading();
    $.ajax({
        url: url,
        type: 'post',
        data: form.serialize(),
        success: function(data){
            $('#container-content').empty().append(data);
            $.fancybox.hideLoading();
        }
    });
}

function selectEigenschap(classname, contentId)
{
    $('.' + classname).hide();
    $('#' + contentId).show();
}

function prefillOptions()
{
    var formaat = getParameterByName('formaat');
    var materiaal = getParameterByName('materiaal');
    var belijming = getParameterByName('belijming');
    var afwerking = getParameterByName('afwerking');
    var aantal = getParameterByName('aantal');

    if(formaat || materiaal || belijming || aantal || afwerking) {
        $.fancybox.showLoading();

        setTimeout(function () {
            var $formaat = $('input[data-slug=' + formaat + ']');
            if ($formaat.length !== 0) {
                $formaat.click();
            } else {
                if (formaat != undefined && formaat != null) {
                    var parts = formaat.split('mm')[0].split('x');
                    var breedte = parts[0];
                    var hoogte = parts[1];
                    $('.custom-formaat-blok').click();
                    $('input[name=custom_formaat_hoogte]').val(hoogte);
                    $('input[name=custom_formaat_breedte]').val(breedte).keyup();
                }
            }

            $('input[data-slug=' + materiaal + ']').click();
            $('input[data-slug=' + belijming + ']').click();
            $('input[data-slug=' + afwerking + ']').click();
            var $aantal = $('input[value=' + aantal + ']');

            if ($aantal.length !== 0) {
                $aantal.click().change();
            } else {
                $('#oplage-optie-custom-invoer').val(aantal).keyup();
                $('#oplage-optie-custom').click().change().keyup();
            }

            if(aantal) {
                // setTimeout(function () {
                //     $aantal.parent().click();
                //     $.fancybox.hideLoading();
                //     // $('#kies-formaat-blok').animate({
                //     //     top: $('#wrapper-step-4').position().top
                //     // });
                // }, 400);
            }else{
                $.fancybox.hideLoading();
            }

        }, 200);
    }
}

var urlTimer = null;
var formatting = false;
function urlFormatter()
{
    if(!formatting) {
        urlTimer = setTimeout(function () {
            var width = 0,
                height = 0,
                newUrl = url;

            var $formaat = $('input[name=producten_formaat_id]:checked');
            if ($formaat.length > 0) {
                width = $formaat.attr('data-breedte');
                height = $formaat.attr('data-hoogte');
                if (width === undefined) width = 0;
                if (height === undefined) height = 0;
            }
            if (width == 0 && height == 0) {

            } else {
                newUrl += './?formaat=' + width + 'x' + height + 'mm';
            }

            var $materiaal = $('input[name=producten_materiaal_id]:checked');
            if ($materiaal.attr('data-slug') == undefined) {
                // newUrl += '&materiaal=geen-materiaal';
            } else {
                newUrl += '&materiaal=' + $materiaal.attr('data-slug');
            }


            var $afwerking = $('input[name=producten_afwerking_id]:checked');
            if ($afwerking.attr('data-slug') == undefined) {
                // newUrl += '&materiaal=geen-materiaal';
            } else {
                newUrl += '&afwerking=' + $afwerking.attr('data-slug');
            }

            var $belijming = $('input[name=producten_belijming_id]:checked');
            if ($belijming.attr('data-slug') == undefined) {
                //  newUrl += '&belijming='+'geen-belijming';
            } else {
                newUrl += '&belijming=' + $belijming.attr('data-slug');
            }

            var number = $('input[name=opties-oplage]:checked').val();
            if (number == 'custom') number = $('#oplage-optie-custom-invoer').val();
            if (number == undefined) number = 0;
            if (number > 0) {
                newUrl += '&aantal=' + number;
            }

            window.history.pushState('', '', newUrl);
            console.log(newUrl);
            var title = $('#product-detail-tekst-titel h1').text();
            // ga('send', 'pageview', { 'page': newUrl, 'title': title });

            formatting = false;
        }, 200);
        formatting = true;
    }
}